import { __decorate, __param } from 'tslib';
import { ɵɵdefineInjectable, Injectable, Inject, ɵɵinject } from '@angular/core';
import { isNotNullOrUndefined } from 'codelyzer/util/isNotNullOrUndefined';

import * as ɵngcc0 from '@angular/core';
let BaseSchemaConfig = class BaseSchemaConfig {
    constructor() {
    }
};
BaseSchemaConfig.ɵfac = function BaseSchemaConfig_Factory(t) { return new (t || BaseSchemaConfig)(); };
BaseSchemaConfig.ɵprov = ɵɵdefineInjectable({ factory: function BaseSchemaConfig_Factory() { return new BaseSchemaConfig(); }, token: BaseSchemaConfig, providedIn: "root" });
function cloneDeep(obj) {
    return JSON.parse(JSON.stringify(obj));
}
let SchemaService = class SchemaService {
    constructor(config) {
        this.config = config;
        this.getSchema = (schemata, typeName) => {
            if (!isNotNullOrUndefined(schemata) || !isNotNullOrUndefined(typeName))
                return null;
            let nameSpaces = typeName.split(".");
            if (nameSpaces.length === 0) {
                return null;
            }
            let nameSpace = schemata;
            nameSpaces.forEach((value, index) => {
                if (nameSpace && nameSpace[value]) {
                    nameSpace = nameSpace[value];
                }
                else {
                    return null;
                }
            });
            return cloneDeep(nameSpace);
        };
        this.getModelSchema = (typeName) => {
            return this.getSchema(this.model.models, typeName);
        };
        this.getEnumSchema = (typeName) => {
            return this.getSchema(this.model.enums, typeName);
        };
        this.getPermissions = () => {
            return cloneDeep(this.model.permissions);
        };
        this.getEnumValueName = (typeName, value) => {
            var _a, _b;
            let values = (_a = this.getSchema(this.model.enums, typeName)) === null || _a === void 0 ? void 0 : _a.values;
            if (!values)
                return '';
            return (_b = Object.getOwnPropertyNames(values)
                .map(k => values[k])
                .find(v => v.value == value)) === null || _b === void 0 ? void 0 : _b.name;
        };
        this.model = config.schema;
    }
};
SchemaService.ɵfac = function SchemaService_Factory(t) { return new (t || SchemaService)(ɵngcc0.ɵɵinject(BaseSchemaConfig)); };
SchemaService.ctorParameters = () => [
    { type: BaseSchemaConfig, decorators: [{ type: Inject, args: [BaseSchemaConfig,] }] }
];
SchemaService.ɵprov = ɵɵdefineInjectable({ factory: function SchemaService_Factory() { return new SchemaService(ɵɵinject(BaseSchemaConfig)); }, token: SchemaService, providedIn: "root" });
SchemaService = __decorate([ __param(0, Inject(BaseSchemaConfig))
], SchemaService);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BaseSchemaConfig, [{
        type: Injectable,
        args: [{ providedIn: "root" }]
    }], function () { return []; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SchemaService, [{
        type: Injectable,
        args: [{ providedIn: "root" }]
    }], function () { return [{ type: BaseSchemaConfig, decorators: [{
                type: Inject,
                args: [BaseSchemaConfig]
            }] }]; }, null); })();
var DataType;
(function (DataType) {
    DataType["custom"] = "Custom";
    DataType["dateTime"] = "DateTime";
    DataType["date"] = "Date";
    DataType["time"] = "Time";
    DataType["duration"] = "Duration";
    DataType["phoneNumber"] = "PhoneNumber";
    DataType["currency"] = "Currency";
    DataType["text"] = "Text";
    DataType["html"] = "Html";
    DataType["multilineText"] = "MultilineText";
    DataType["emailAddress"] = "EmailAddress";
    DataType["password"] = "Password";
    DataType["url"] = "Url";
    DataType["imageUrl"] = "ImageUrl";
    DataType["creditCard"] = "CreditCard";
    DataType["postalCode"] = "PostalCode";
    DataType["upload"] = "Upload";
})(DataType || (DataType = {}));
var AggregationHint;
(function (AggregationHint) {
    AggregationHint["group"] = "Group";
    AggregationHint["count"] = "Count";
    AggregationHint["sum"] = "Sum";
    AggregationHint["min"] = "Min";
    AggregationHint["max"] = "Max";
    AggregationHint["concatenate"] = "Concatenate";
})(AggregationHint || (AggregationHint = {}));

/*
 * Public API Surface of schema
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AggregationHint, BaseSchemaConfig, DataType, SchemaService, cloneDeep };

//# sourceMappingURL=intellis-schema.js.map